module.exports = __webpack_public_path__ + "img/aboutUS-init.92e59441.svg";